import React, { useEffect, FC, useState, useCallback } from "react";
import { Modal, ModalBody, Alert } from "reactstrap";
import { Icon, Button,} from "../../../components/Component";
import { Row, Col } from "reactstrap";
import { FormProvider, useForm } from "react-hook-form";
import FormSelect from "../../form-components/SelectComponent";
import FormInput from "../../form-components/InputComponent";
import FormTextArea from "../../form-components/TextAreaComponent";
import workCategoryApi from "../../../api/master/workCategory";

const EditModal: FC<any> = ({
  modal,
  closeModal,
  onSubmit,
  formData,
  alertInfo,
}) => {
  const methods = useForm({
    mode: "onChange",
  });

  const {
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = methods;

  const [categoryType, setCategoryType] = useState([]);

  const getcategoryType = useCallback(async () => {
    try {
      const matCats = await workCategoryApi.fetchCategoryType();
      console.log(matCats);
      if (matCats.status && matCats.data.length > 0) {
        const transformedData = matCats.data.map((item: any) => ({
          value: item.workCategoryId.toString(),
          label: item.workCategoryName,
        }));
        setCategoryType(transformedData);
      }
    } catch (error: any) {
      console.error("Failed to fetch org types:", error.message);
    }
  }, []);

  useEffect(() => {
    console.log("formDataEDittt",formData)
    reset(formData);
    getcategoryType();
    setValue("referenceID", formData?.referenceID);
    setValue("workCategoryID", formData?.workCategoryID);
    setValue("categoryName", formData?.categoryName);
    setValue("description", formData?.description);
  }, [formData, reset, getcategoryType]);

  return (
    <Modal
      isOpen={modal}
      toggle={() => closeModal()}
      className="modal-dialog-centered"
      size="lg"
      backdrop="static"
    >
      <ModalBody>
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            closeModal();
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>
        <div className="p-2">
          <h5 className="title">Update Work Category</h5>
          {alertInfo.message && (
            <div className="mb-3 mt-1">
              <Alert
                color={alertInfo.type === "error" ? "danger" : "success"}
                className="alert-icon"
              >
                <strong>{alertInfo.message}</strong>
                <Icon
                  name={
                    alertInfo.type === "error" ? "alert-circle" : "check-circle"
                  }
                />
                {alertInfo.errors.length > 0 ? (
                  <ul>
                    {alertInfo.errors.map((err: any, index: any) => (
                      <li key={index}>{err}</li>
                    ))}
                  </ul>
                ) : (
                  ""
                )}
              </Alert>
            </div>
          )}
          <div className="mt-4">
            <FormProvider {...methods}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                  <Col lg="4">
                    <FormInput
                      name="referenceID"
                      label="Work Category ID"
                      required={true}
                      type="text"
                      // pattern={/^[a-zA-Z0-9./_-]+$/}
                      placeholder="Enter Work Category ID"
                      // disabled={action === "view"}
                    />
                  </Col>
                  <Col lg="4">
                    <FormSelect
                      options={categoryType}
                      name="workCategoryID"
                      label="Work Type"
                      required={true}
                      placeholder="Enter Work Type"
                      // type="text"
                      // disabled={action === "view"}
                    />
                  </Col>
                  <Col lg="4">
                    <FormInput
                      name="categoryName"
                      label="Category Name"
                      required={true}
                      placeholder="Enter Category Name"
                      type="text"
                      // disabled={action === "view"}
                    />
                  </Col>
                  <Col md="12" className="mt-2">
                    <FormTextArea
                      name="description"
                      label="Description"
                      required={true}
                      maxLength={50}
                      placeholder="Enter Description"
                    />
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col size="12">
                    {" "}
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button
                          color="primary"
                          size="md"
                          type="submit"
                          // onClick={() => handleFormSubmit(formData)}
                        >
                          Update
                        </Button>
                      </li>
                      <li>
                        <a
                          href="#cancel"
                          onClick={(ev) => {
                            ev.preventDefault();
                            closeModal();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </a>
                      </li>
                    </ul>
                  </Col>
                </Row>
                {/* )} */}
              </form>
            </FormProvider>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default EditModal;